<app-layout>
    <div class="table-components page-section">

        <!-- components title start -->
        <div class="components-title">

            <div>
                <inertia-link :href="route('home')">Home</inertia-link> &rarr; <inertia-link :href="route('articles')">{{ $t('News & Announcements')}}</inertia-link> &rarr; <span>{{ $t('Details') }}</span>
            </div>

        <div class="flex flex-wrap -m-4 components-title">
  <div class="w-full md:w-1/2 lg:w-2/4 xl:w-3/5 p-4">
    <!-- Content on the left side -->
    <!-- Your existing content here -->
<h1>{{ article.title }}</h1>
<p>{{ $t('Published at:') }} {{ article.created_at }}</p>
  </div>
  <div class="w-full md:w-1/2 lg:w-2/4 xl:w-2/5 p-4">
    <!-- Image on the right side -->
    <div class="rounded-lg">
      <img class="h-56 rounded w-full object-center mb-6" :src="article.thumbnail" alt="content">
    </div>
  </div>
</div>    

        </div>
        <!-- components title end -->

        <div class="min-h-screen page-section-content">
            <div v-html="cleanMessage" class="w-full mt-10 prose"></div>
        </div>




    </div>

</app-layout>
